module.exports = __webpack_public_path__ + "media/logos/gmail-9d6b3500.svg";